import { Flex } from "Element/Flex";
import React from "react";
import { StyledHeroText } from "../styled";
import {
  Description,
  WavesContainer,
  WavesImg,
  WavesName,
  WavesWrapper,
  TheWave,
} from "./styled";
import { waveList } from "./wavesList";

const Waves = () => {
  return (
    <WavesWrapper>
      <StyledHeroText textAlign="left">
        Wave Sales with Dogey goodness
      </StyledHeroText>
      <Flex className="desc-wrapper" flexDirection="column">
        <Description>
          Having only one initial sale reduces opportunities for more holders to
          join the sale. Learning from Sandbox Land Wave Sales, Doge NFTs will
          be spread out over different wave sales and generations, capping all
          DogeNFTs at 10k.
        </Description>
        <Description>
          Wave sales will have different themes and prices but will always have
          an incentive to reward earlier investors. Some wave sales will be
          differentiated with color, attributes and utility; some will have
          discounted minting fees due to collaborations with other communities.
          All of these decisions will be determined by the community.
        </Description>
      </Flex>
      <WavesContainer width="100%" justifyContent="center">
        {waveList.map((wave, idx) => (
          <TheWave key={idx} flexDirection="column">
            <WavesImg width={200} src={wave.img} alt="" />
            <WavesName>{wave.name}</WavesName>
          </TheWave>
        ))}
      </WavesContainer>
    </WavesWrapper>
  );
};

export default Waves;
